import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Typography, useMediaQuery, useTheme, Switch } from '@mui/material';
import Grid from '@mui/material/Grid2';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { StyledMenu } from '@ui/components/common/Menu';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_INVITATION_EMAIL_TEMPLATE_HTML, DEFAULT_EMAIL_PLACEHOLDER_VALUES } from './templates/english/invitationEmailDefaultEng';
import { TICKET_CONFIRMATION_EMAIL_TEMPLATE_HTML, DEFAULT_TICKET_CONFIRMATION_PLACEHOLDER_VALUES } from './templates/english/ticketConfirmationEmailDefaultEng';
import { DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_ENG, DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_ENG } from './templates/english/thankYouEmailDefaultEng';
import { DEFAULT_REINVITATION_REMINDER_EMAIL_TEMPLATE_HTML_ENG, DEFAULT_EMAIL_PLACEHOLDER_VALUES_REINVITATION_REMINDER_ENG } from './templates/english/reinvitationreminderEmailDefaultEng';
import { DEFAULT_REINVITATION_REMINDER_EMAIL_TEMPLATE_HTML_DUTCH, DEFAULT_EMAIL_PLACEHOLDER_VALUES_REINVITATION_REMINDER_DUTCH } from './templates/dutch/reinvitationreminderEmailDefaultDutch';
import { DEFAULT_REINVITATION_REMINDER_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_REINVITATION_REMINDER_GERMAN } from './templates/german/reinvitationreminderEmailDefaultGerman';
import { DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_ENG, DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_ENG } from './templates/english/registeredreminderEmailDefaultEng';
import { DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_DUTCH, DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_DUTCH } from './templates/dutch/registeredreminderEmailDefaultDutch';
import { DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_GERMAN } from './templates/german/registeredreminderEmailDefaultGerman';
import { DEFAULT_INVITATION_EMAIL_TEMPLATE_HTML_DUTCH, DEFAULT_EMAIL_PLACEHOLDER_VALUES_DUTCH } from './templates/dutch/invitationEmailDefaultDutch';
import { TICKET_CONFIRMATION_EMAIL_TEMPLATE_HTML_NL, DEFAULT_TICKET_CONFIRMATION_PLACEHOLDER_VALUES_NL } from './templates/dutch/ticketConfirmationEmailDutch';
import { DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_DUTCH, DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_DUTCH } from './templates/dutch/thankYouEmailDefaultDutch';
import { DEFAULT_INVITATION_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_GERMAN } from './templates/german/invitationEmailDefaultGerman';
import { DEFAULT_TICKET_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_TICKET_GERMAN } from './templates/german/ticketConfirmationEmailDefaultGerman';
import { DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_GERMAN } from './templates/german/thankYouEmailDefautGerman';
import { DEFAULT_FINAL_DETAILS_EMAIL_TEMPLATE_HTML_ENG, DEFAULT_EMAIL_PLACEHOLDER_VALUES_FINAL_DETAILS_ENG } from './templates/english/finaldetailEmailDefaultEng';
import { DEFAULT_FINAL_DETAILS_EMAIL_TEMPLATE_HTML_DUTCH, DEFAULT_EMAIL_PLACEHOLDER_VALUES_FINAL_DETAILS_DUTCH } from './templates/dutch/finaldetailEmailDefaultDutch';
import { DEFAULT_FINAL_DETAILS_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_FINAL_DETAILS_GERMAN } from './templates/german/finaldetailEmailDefaultGerman';
import { DEFAULT_POST_EVENT_THANK_YOU_EMAIL_TEMPLATE_HTML_ENG, DEFAULT_EMAIL_PLACEHOLDER_VALUES_POST_EVENT_THANK_YOU_ENG } from './templates/english/postEventThankYouEmailDefaultEng';
import { DEFAULT_POST_EVENT_THANK_YOU_EMAIL_TEMPLATE_HTML_DUTCH, DEFAULT_EMAIL_PLACEHOLDER_VALUES_POST_EVENT_THANK_YOU_DUTCH } from './templates/dutch/postEventThankYouEmailDefaultDutch';
import { DEFAULT_POST_EVENT_THANK_YOU_EMAIL_TEMPLATE_HTML_GERMAN, DEFAULT_EMAIL_PLACEHOLDER_VALUES_POST_EVENT_THANK_YOU_GERMAN } from './templates/german/postEventThankYouEmailDefaultGerman';
import { hasPermission } from '@application/helpers/permission-helper';
import { useController } from 'react-hook-form';
import TextEditor from '@ui/components/TextEditor';
import EmailPreview from './EmailPreview';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useMemo } from 'react';
import { flattenEmailHeadingParagraphs, flattenEmailSingleLineParagraphs, stripEditorParagraphTags } from '@application/utilities/email-editor-typography';
import { captureScrollPositions, restoreConfigureEmailScroll, restoreScrollPositionsDeferred } from '@application/utilities/email-editor-scroll-guard';
import { getIdentityFormFieldsByEventIdAsync } from '@application/features/formField/formFieldThunk';
import { Icon } from '@iconify/react';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
import { getEventLanguagesByEventIdAsync } from '@application/features/languages/languagesThunk';
import { EmailTemplateType } from '@application/features/emailTemplates/models/email-template-type';
import { EmailTemplateStatus } from '@application/features/emailTemplates/models/email-template-status';
import { EmailTemplateImageRole } from '@application/features/emailTemplates/models/email-template-image-role';
import { getEmailTemplateByContextAsync, upsertEmailTemplateAsync } from '@application/features/emailTemplates/emailTemplatesThunk';
import { APIStatus } from '@application/enums/api-status';
import { useEmailContrastColor, useEmailPrimaryColor, mapPrimaryColorToIconFolder } from '@ui/hooks/useEmailBranding';
import BDrawer from '@ui/components/common/BDrawer';
import { getLocalTimeFromDateForEmailTemplate } from '@application/utilities/date-time-formater';
import { formatEventDate } from '@application/utilities/date-helper';
/** Wraps all {{...}} meta tags in a span so they can be styled (e.g. blue) in the editor. */
function wrapMetaTagsInSpans(html) {
    if (!html)
        return html;
    const unwrapped = html.replace(/<span class="email-meta-tag">(\{\{[^}]+\}\})<\/span>/g, '$1');
    return unwrapped.replace(/\{\{[^}]+\}\}/g, (match) => `<span class="email-meta-tag">${match}</span>`);
}
/** Map token id (sys:... or field:guid) -> display label. Used to show labels in editor, store ids in value. */
function buildTokenToLabelMap(systemTags, identityFormFields) {
    const map = {};
    systemTags.forEach((t) => {
        map[t.id] = t.label;
    });
    (identityFormFields ?? []).forEach((f) => {
        map[`field:${f.id}`] = f.label;
    });
    return map;
}
function buildLabelToTokenMap(systemTags, identityFormFields) {
    const normalize = (value) => value.trim().toLowerCase().replace(/\s+/g, ' ');
    const map = {};
    systemTags.forEach((tag) => {
        map[normalize(tag.label)] = tag.id;
        map[normalize(tag.id)] = tag.id;
    });
    (identityFormFields ?? []).forEach((field) => {
        const id = `field:${field.id}`;
        map[normalize(field.label)] = id;
        map[normalize(id)] = id;
    });
    return map;
}
/** Convert stored tokens {{id}} to display spans with label and data-token for round-trip. */
function tokensToLabels(html, idToLabel) {
    if (!html)
        return html;
    let out = html.replace(/<span\s+[^>]*class="[^"]*email-meta-tag[^"]*"[^>]*>(\{\{[^}]+\}\})<\/span>/gi, '$1');
    out = out.replace(/\{\{([^}]+)\}\}/g, (_, id) => {
        const label = idToLabel[id.trim()] ?? id;
        return `<span class="email-meta-tag" data-token="${id.replace(/"/g, '&quot;')}">{{${label}}}</span>`;
    });
    return out;
}
/** Convert stored tokens {{id}} to plain display labels {{Label}} for preview rendering. */
function tokensToDisplayLabels(html, idToLabel) {
    if (!html)
        return html;
    return html.replace(/\{\{([^}]+)\}\}/g, (_, id) => {
        const label = idToLabel[id.trim()] ?? id.trim();
        return `{{${label}}}`;
    });
}
/** Convert editor HTML back to stored form: spans with data-token or {{id}} -> {{id}}. */
function labelsToTokens(html, labelToTokenMap) {
    if (!html)
        return html;
    let out = html;
    out = out.replace(/<span\s+[^>]*data-token="([^"]*)"[^>]*class="[^"]*email-meta-tag[^"]*"[^>]*>[\s\S]*?<\/span>/gi, (_, id) => `{{${id}}}`);
    out = out.replace(/<span\s+[^>]*class="[^"]*email-meta-tag[^"]*"[^>]*data-token="([^"]*)"[^>]*>[\s\S]*?<\/span>/gi, (_, id) => `{{${id}}}`);
    out = out.replace(/<span\s+[^>]*class="[^"]*email-meta-tag[^"]*"[^>]*>\s*(\{\{[^}]+\}\})\s*<\/span>/gi, '$1');
    out = out.replace(/\{\{([^}]+)\}\}/g, (_, tokenLike) => {
        const normalized = tokenLike.trim().toLowerCase().replace(/\s+/g, ' ');
        const resolved = labelToTokenMap[normalized] ?? tokenLike.trim();
        return `{{${resolved}}}`;
    });
    return out;
}
/** Wrap plain text in <p>; leave content that already has block tags (p/ol/ul) as-is. */
function ensureParagraphHtml(value) {
    const v = (value ?? '').trim();
    if (!v)
        return '<p></p>';
    if (/^<(p|ol|ul)[\s>]/i.test(v))
        return v;
    return `<p>${v}</p>`;
}
function prepareHeadingEditorHtml(value) {
    return flattenEmailHeadingParagraphs(wrapMetaTagsInSpans(ensureParagraphHtml(value ?? '')));
}
function resolveEmailLanguageCode(languageInput) {
    const normalized = (languageInput ?? '').trim().toLowerCase();
    if (normalized.startsWith('nl') || normalized.includes('dutch'))
        return 'nl';
    if (normalized.startsWith('de') || normalized.includes('german'))
        return 'de';
    return 'en';
}
function getTemplateDefaults(templateType, languageCode) {
    if (templateType === EmailTemplateType.Ticket) {
        if (languageCode === 'nl') {
            return {
                htmlTemplate: TICKET_CONFIRMATION_EMAIL_TEMPLATE_HTML_NL,
                placeholderValues: DEFAULT_TICKET_CONFIRMATION_PLACEHOLDER_VALUES_NL
            };
        }
        if (languageCode === 'de') {
            return {
                htmlTemplate: DEFAULT_TICKET_EMAIL_TEMPLATE_HTML_GERMAN,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_TICKET_GERMAN
            };
        }
        return {
            htmlTemplate: TICKET_CONFIRMATION_EMAIL_TEMPLATE_HTML,
            placeholderValues: DEFAULT_TICKET_CONFIRMATION_PLACEHOLDER_VALUES
        };
    }
    if (templateType === EmailTemplateType.WelcomeThankYou) {
        if (languageCode === 'nl') {
            return {
                htmlTemplate: DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_DUTCH,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_DUTCH
            };
        }
        if (languageCode === 'de') {
            return {
                htmlTemplate: DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_GERMAN,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_GERMAN
            };
        }
        return {
            htmlTemplate: DEFAULT_THANK_YOU_EMAIL_TEMPLATE_HTML_ENG,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_THANK_YOU_ENG
        };
    }
    if (templateType === EmailTemplateType.ReInvitationReminder) {
        if (languageCode === 'nl') {
            return {
                htmlTemplate: DEFAULT_REINVITATION_REMINDER_EMAIL_TEMPLATE_HTML_DUTCH,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_REINVITATION_REMINDER_DUTCH
            };
        }
        if (languageCode === 'de') {
            return {
                htmlTemplate: DEFAULT_REINVITATION_REMINDER_EMAIL_TEMPLATE_HTML_GERMAN,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_REINVITATION_REMINDER_GERMAN
            };
        }
        return {
            htmlTemplate: DEFAULT_REINVITATION_REMINDER_EMAIL_TEMPLATE_HTML_ENG,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_REINVITATION_REMINDER_ENG
        };
    }
    if (templateType === EmailTemplateType.RegisteredReminder) {
        if (languageCode === 'nl') {
            return {
                htmlTemplate: DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_DUTCH,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_DUTCH
            };
        }
        if (languageCode === 'de') {
            return {
                htmlTemplate: DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_GERMAN,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_GERMAN
            };
        }
        return {
            htmlTemplate: DEFAULT_REGISTERED_REMINDER_EMAIL_TEMPLATE_HTML_ENG,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_REGISTERED_REMINDER_ENG
        };
    }
    if (templateType === EmailTemplateType.FinalDetails) {
        if (languageCode === 'nl') {
            return {
                htmlTemplate: DEFAULT_FINAL_DETAILS_EMAIL_TEMPLATE_HTML_DUTCH,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_FINAL_DETAILS_DUTCH
            };
        }
        if (languageCode === 'de') {
            return {
                htmlTemplate: DEFAULT_FINAL_DETAILS_EMAIL_TEMPLATE_HTML_GERMAN,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_FINAL_DETAILS_GERMAN
            };
        }
        return {
            htmlTemplate: DEFAULT_FINAL_DETAILS_EMAIL_TEMPLATE_HTML_ENG,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_FINAL_DETAILS_ENG
        };
    }
    if (templateType === EmailTemplateType.PostEventThankYou) {
        if (languageCode === 'nl') {
            return {
                htmlTemplate: DEFAULT_POST_EVENT_THANK_YOU_EMAIL_TEMPLATE_HTML_DUTCH,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_POST_EVENT_THANK_YOU_DUTCH
            };
        }
        if (languageCode === 'de') {
            return {
                htmlTemplate: DEFAULT_POST_EVENT_THANK_YOU_EMAIL_TEMPLATE_HTML_GERMAN,
                placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_POST_EVENT_THANK_YOU_GERMAN
            };
        }
        return {
            htmlTemplate: DEFAULT_POST_EVENT_THANK_YOU_EMAIL_TEMPLATE_HTML_ENG,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_POST_EVENT_THANK_YOU_ENG
        };
    }
    if (languageCode === 'nl') {
        return {
            htmlTemplate: DEFAULT_INVITATION_EMAIL_TEMPLATE_HTML_DUTCH,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_DUTCH
        };
    }
    if (languageCode === 'de') {
        return {
            htmlTemplate: DEFAULT_INVITATION_EMAIL_TEMPLATE_HTML_GERMAN,
            placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES_GERMAN
        };
    }
    return {
        htmlTemplate: DEFAULT_INVITATION_EMAIL_TEMPLATE_HTML,
        placeholderValues: DEFAULT_EMAIL_PLACEHOLDER_VALUES
    };
}
/** Default slot HTML for each editor from chosen template placeholders (with {{tokens}} wrapped for display). */
function getDefaultSlotHtml(placeholderValues) {
    const d = placeholderValues;
    return {
        emailHeadingHtml: prepareHeadingEditorHtml(d.emailHeading ?? ''),
        emailBodyHtml: wrapMetaTagsInSpans(d.emailBody ?? ''),
        emailEventDetailsHeadingHtml: wrapMetaTagsInSpans(ensureParagraphHtml(d.emailEventDetailsHeading ?? '')),
        emailEventDetailsSubtextHtml: wrapMetaTagsInSpans(ensureParagraphHtml(d.emailEventDetailsSubtext ?? '')),
        emailBadgeHtml: wrapMetaTagsInSpans(d.emailBadge ?? ''),
        emailButtonTextHtml: wrapMetaTagsInSpans(d.emailButtonText ?? '')
    };
}
const EMAIL_FIELD_EDITOR_PRESET = {
    emailHeadingHtml: 'heading',
    emailBodyHtml: 'body',
    emailEventDetailsHeadingHtml: 'detailsHeading',
    emailEventDetailsSubtextHtml: 'detailsSubtext',
    emailBadgeHtml: 'badge',
    emailButtonTextHtml: 'buttonText'
};
const EMAIL_BADGE_TEXT_LIMIT = 60;
const EMAIL_BUTTON_TEXT_LIMIT = 45;
const EmailBodyEditor = ({ control, name, tokenToLabelMap, labelToTokenMap, editorRef, onEditorFocus, forceSyncToken }) => {
    const { field } = useController({
        name,
        control
    });
    const [localValue, setLocalValue] = React.useState(() => tokensToLabels(field.value ?? '', tokenToLabelMap));
    const lastSentValueRef = React.useRef(null);
    // Keep refs so the stable onChange callback can always read the latest values
    // without being recreated on every render (which would cause an infinite loop
    // via TextEditor's syncEmailPresetFormats useEffect).
    const labelToTokenMapRef = React.useRef(labelToTokenMap);
    labelToTokenMapRef.current = labelToTokenMap;
    const fieldValueRef = React.useRef(field.value);
    fieldValueRef.current = field.value;
    const fieldOnChangeRef = React.useRef(field.onChange);
    fieldOnChangeRef.current = field.onChange;
    React.useEffect(() => {
        if (lastSentValueRef.current !== null && (field.value ?? '') === lastSentValueRef.current) {
            lastSentValueRef.current = null;
            return;
        }
        lastSentValueRef.current = null;
        const nextDisplay = tokensToLabels(field.value ?? '', tokenToLabelMap);
        setLocalValue((prev) => (prev === nextDisplay ? prev : nextDisplay));
    }, [field.value, tokenToLabelMap]);
    const handleChange = React.useCallback((html, source) => {
        setLocalValue(html);
        if (source === 'preset')
            return;
        const nextValue = labelsToTokens(html, labelToTokenMapRef.current);
        if (nextValue !== (fieldValueRef.current ?? '')) {
            lastSentValueRef.current = nextValue;
            fieldOnChangeRef.current(nextValue);
        }
    }, []);
    const preset = EMAIL_FIELD_EDITOR_PRESET[name];
    const isPlainTextOnly = preset === 'badge' || preset === 'buttonText';
    const maxCharacters = preset === 'badge'
        ? EMAIL_BADGE_TEXT_LIMIT
        : preset === 'buttonText'
            ? EMAIL_BUTTON_TEXT_LIMIT
            : undefined;
    return (_jsx(TextEditor, { ref: editorRef, value: localValue, onChange: handleChange, useStyleAttributors: true, emailEditorPreset: preset, hideToolbar: isPlainTextOnly, maxCharacters: maxCharacters, onFocus: onEditorFocus ? () => onEditorFocus(name) : undefined, forceSyncToken: forceSyncToken }));
};
const EmailConfiguration = ({ templateTitle, templateType }) => {
    // HOOKS START HERE //
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { eventId } = useParams();
    const dispatch = useAppDispatch();
    const emailPrimaryColor = useEmailPrimaryColor();
    const emailContrastColor = useEmailContrastColor();
    // HOOKS END HERE //
    // REFS START HERE //
    const headingEditorRef = useRef(null);
    const bodyEditorRef = useRef(null);
    const detailsHeadingEditorRef = useRef(null);
    const detailsSubtextEditorRef = useRef(null);
    const badgeEditorRef = useRef(null);
    const buttonTextEditorRef = useRef(null);
    const editorScrollPanelRef = useRef(null);
    const editorRefs = {
        emailHeadingHtml: headingEditorRef,
        emailBodyHtml: bodyEditorRef,
        emailEventDetailsHeadingHtml: detailsHeadingEditorRef,
        emailEventDetailsSubtextHtml: detailsSubtextEditorRef,
        emailBadgeHtml: badgeEditorRef,
        emailButtonTextHtml: buttonTextEditorRef
    };
    const activeEditorNameRef = useRef(null);
    // REFS END HERE //
    // SELECTORS START HERE //
    const { VDKEventsForEventDetails } = useAppSelector((state) => state.VDKEvent);
    const { selectedCompanyId } = useAppSelector((state) => state.company);
    const selectedUser = useAppSelector((state) => state.auth.currentUser);
    const { identityFormFields } = useAppSelector((state) => state.formField);
    const { eventLanguages } = useAppSelector((state) => state.languages);
    const { status: emailTemplateStatus, selectedEmailTemplate } = useAppSelector((state) => state.emailTemplates);
    const loggedInUserPermissions = useAppSelector((state) => state.auth.currentUser?.permissions || []);
    // SELECTORS END HERE //
    // STATES START HERE //
    const [activeEditorName, setActiveEditorName] = useState(null);
    const [insertMenuAnchor, setInsertMenuAnchor] = useState(null);
    const [headerImageFile, setHeaderImageFile] = useState(null);
    const [featureImageFile, setFeatureImageFile] = useState(null);
    const [isPreviewDrawerOpen, setIsPreviewDrawerOpen] = useState(false);
    const [showHeaderImage, setShowHeaderImage] = useState(true);
    const [showFeatureImage, setShowFeatureImage] = useState(true);
    const [imagesResetToDefault, setImagesResetToDefault] = useState(false);
    // STATES END HERE //
    const effectiveLanguageCode = useMemo(() => resolveEmailLanguageCode(selectedEmailTemplate?.languageName ||
        i18n.language ||
        DEFAULT_EMAIL_PLACEHOLDER_VALUES.language), [selectedEmailTemplate?.languageName, i18n.language]);
    const templateDefaults = useMemo(() => getTemplateDefaults(templateType, effectiveLanguageCode), [templateType, effectiveLanguageCode]);
    const defaultSlotHtml = useMemo(() => getDefaultSlotHtml(templateDefaults.placeholderValues), [templateDefaults.placeholderValues]);
    const handleEditorFocus = (name) => {
        activeEditorNameRef.current = name;
        setActiveEditorName(name);
    };
    const GetTranslatedTitle = (templateTitle) => {
        if (templateTitle === 'Invitation Email' ||
            templateTitle === 'Uitnodigingsmail' ||
            templateTitle === 'Einladungs-E-Mail') {
            return t(`events.eventDetails.preferencesTab.emailConfiguration.invitationEmail`);
        }
        if (templateTitle === 'Thank You Email' ||
            templateTitle === 'Bedankmail' ||
            templateTitle === 'Dankes-E-Mail') {
            return t(`events.eventDetails.preferencesTab.emailConfiguration.thankYouEmail`);
        }
        if (templateTitle === 'Ticket Confirmation Email' ||
            templateTitle === 'Ticketbevestigingsmail' ||
            templateTitle === 'Ticketbestätigungs-E-Mail') {
            return t(`events.eventDetails.preferencesTab.emailConfiguration.ticketEmail`);
        }
        if (templateTitle === 'Re-Invitation Reminder Email' ||
            templateTitle === 'Herinnering opnieuw uitnodigen' ||
            templateTitle === 'Erneute Einladungserinnerung') {
            return t(`events.eventDetails.preferencesTab.emailConfiguration.reInvitationReminderEmail`);
        }
        if (templateTitle === 'Registered Reminder Email' ||
            templateTitle === 'Geregistreerde herinnering' ||
            templateTitle === 'Registrierungserinnerung') {
            return t(`events.eventDetails.preferencesTab.emailConfiguration.registeredReminderEmail`);
        }
        return templateTitle;
    };
    // EFFECTS START HERE //
    React.useEffect(() => {
        if (eventId) {
            dispatch(getEventLanguagesByEventIdAsync(eventId));
        }
    }, [dispatch, eventId]);
    React.useEffect(() => {
        if (!eventLanguages)
            return;
        let hasSelectedLanguage = eventLanguages.find((lang) => lang.code.toLocaleLowerCase() === i18n.language.toLocaleLowerCase());
        // Fallback: If the Application language is not available in the event languages, we will use the primary Language of the event
        if (!hasSelectedLanguage) {
            hasSelectedLanguage = eventLanguages.find((lang) => lang.isPrimary);
        }
        if (eventId) {
            dispatch(getIdentityFormFieldsByEventIdAsync({
                eventId,
                languageId: hasSelectedLanguage?.id,
                templateType
            }));
        }
    }, [dispatch, eventLanguages, i18n.language]);
    React.useEffect(() => {
        if (eventId) {
            dispatch(getEmailTemplateByContextAsync({ eventId, templateType }));
        }
    }, [dispatch, eventId, templateType]);
    React.useEffect(() => {
        if (selectedEmailTemplate) {
            setShowHeaderImage(selectedEmailTemplate.showHeaderImage !== false);
            setShowFeatureImage(selectedEmailTemplate.showFeatureImage !== false);
            setHeaderImageFile(null);
            setFeatureImageFile(null);
            setImagesResetToDefault(false);
        }
    }, [selectedEmailTemplate?.id]);
    // EFFECTS END HERE //
    const headerImagePreview = useMemo(() => (headerImageFile ? URL.createObjectURL(headerImageFile) : ''), [headerImageFile]);
    const featureImagePreview = useMemo(() => (featureImageFile ? URL.createObjectURL(featureImageFile) : ''), [featureImageFile]);
    const eventPlaceholderOverrides = useMemo(() => {
        const event = VDKEventsForEventDetails;
        const overrides = {};
        if (event) {
            overrides['event.title'] = event.title ?? '';
            overrides['sys:eventName'] = event.title ?? '';
            if (event.startDate) {
                const start = formatEventDate(event.startDate, effectiveLanguageCode);
                overrides['event.date'] = start;
                overrides['sys:eventStartDate'] = start;
                if (!event.isMultiDayEvent) {
                    overrides['sys:eventDate'] = start;
                }
            }
            if (event.startTime) {
                const start = getLocalTimeFromDateForEmailTemplate(event.startTime);
                overrides['event.timeStart'] = start ?? '';
                overrides['sys:eventStartTime'] = start ?? '';
            }
            if (event.endDate) {
                const end = formatEventDate(event.endDate, effectiveLanguageCode);
                overrides['sys:eventEndDate'] = end;
            }
            if (event.endTime) {
                const end = getLocalTimeFromDateForEmailTemplate(event.endTime);
                overrides['event.timeEnd'] = end ?? '';
                overrides['sys:eventEndTime'] = end ?? '';
            }
            if (event.isMultiDayEvent) {
                overrides['sys:eventDate'] = `${formatEventDate(event.startDate, effectiveLanguageCode)} - ${formatEventDate(event.endDate, effectiveLanguageCode)}`;
            }
            const eventWithLocation = event;
            if (eventWithLocation.location) {
                overrides['event.location.address'] = eventWithLocation.location;
                overrides['event.location.city'] = '';
                overrides['sys:eventLocation'] = `${eventWithLocation.location}`;
            }
            if (event.description) {
                overrides['sys:eventDescription'] = event.description ?? '';
            }
        }
        // Header Image
        if (showHeaderImage) {
            if (headerImagePreview) {
                overrides['Rectangle.Img'] = headerImagePreview;
            }
            else if (!imagesResetToDefault) {
                const headerImg = selectedEmailTemplate?.images?.find((img) => img.imageRole === EmailTemplateImageRole.Header);
                if (headerImg)
                    overrides['Rectangle.Img'] = headerImg.url;
            }
            overrides['HeaderImageBlock_START'] = '';
            overrides['HeaderImageBlock_END'] = '';
        }
        else {
            overrides['Rectangle.Img'] = '';
            overrides['HeaderImageBlock_START'] = '<!--';
            overrides['HeaderImageBlock_END'] = '-->';
        }
        // Feature Image
        if (showFeatureImage) {
            if (featureImagePreview) {
                overrides['Welcome.Img'] = featureImagePreview;
            }
            else if (!imagesResetToDefault) {
                const featureImg = selectedEmailTemplate?.images?.find((img) => img.imageRole === EmailTemplateImageRole.Body);
                if (featureImg)
                    overrides['Welcome.Img'] = featureImg.url;
            }
            overrides['FeatureImageBlock_START'] = '';
            overrides['FeatureImageBlock_END'] = '';
        }
        else {
            overrides['Welcome.Img'] = '';
            overrides['FeatureImageBlock_START'] = '<!--';
            overrides['FeatureImageBlock_END'] = '-->';
        }
        // Branding colors: Primary_Color and Contrast_Color from selected company theme.
        if (emailPrimaryColor) {
            overrides['Primary_Color'] = emailPrimaryColor;
        }
        overrides['Contrast_Color'] = emailContrastColor;
        if (emailPrimaryColor) {
            const iconFolder = mapPrimaryColorToIconFolder(emailPrimaryColor);
            overrides['Date.Icon'] = `/assets/images/${iconFolder}/Date.png`;
            overrides['Time.Icon'] = `/assets/images/${iconFolder}/Time.png`;
            overrides['Location.Icon'] = `/assets/images/${iconFolder}/Location.png`;
            overrides['Arrow.Icon'] = `/assets/images/${iconFolder}/Icon.png`;
            overrides['Dot.Icon'] = `/assets/images/${iconFolder}/Dot.png`;
            overrides['Network.Icon'] = `/assets/images/${iconFolder}/Network.png`;
            overrides['Name.Icon'] = `/assets/images/${iconFolder}/Name.png`;
            overrides['Ocassion.Icon'] = `/assets/images/${iconFolder}/Ocassion.png`;
            overrides['Seat.Icon'] = `/assets/images/${iconFolder}/Seat.png`;
            overrides['Time.Icon'] = `/assets/images/${iconFolder}/Time.png`;
        }
        return overrides;
    }, [
        VDKEventsForEventDetails,
        selectedEmailTemplate,
        headerImagePreview,
        featureImagePreview,
        emailPrimaryColor,
        emailContrastColor,
        templateType,
        showHeaderImage,
        showFeatureImage,
        imagesResetToDefault
    ]);
    const companyLogoPlaceholderOverride = useMemo(() => {
        const overrides = {};
        if (selectedUser?.primaryCompanyId &&
            selectedCompanyId?.length === 1 &&
            selectedCompanyId[0] === selectedUser?.primaryCompanyId) {
            overrides['branding.logoUrl'] = selectedUser?.primaryCompanyLogoUrl ?? '';
        }
        overrides['branding.logoUrl'] = selectedUser?.companyLogoUrl ?? '';
        return overrides;
    }, [selectedUser, selectedCompanyId]);
    // const defaultEmailBodyHtml = useMemo(
    //   () => tokensToLabels(DEFAULT_NEW_EVENT_EMAIL_BODY, buildTokenToLabelMap([], identityFormFields)),
    //   [identityFormFields]
    // );
    const tokenToLabelMap = useMemo(() => buildTokenToLabelMap([], identityFormFields), [identityFormFields]);
    const labelToTokenMap = useMemo(() => buildLabelToTokenMap([], identityFormFields), [identityFormFields]);
    const canUpdateEvents = hasPermission(loggedInUserPermissions, 'Permissions.VdkEvents.Update');
    const { control, watch, setValue, reset } = useForm({
        defaultValues: {
            emailHeadingHtml: defaultSlotHtml.emailHeadingHtml,
            emailBodyHtml: defaultSlotHtml.emailBodyHtml,
            emailEventDetailsHeadingHtml: defaultSlotHtml.emailEventDetailsHeadingHtml,
            emailEventDetailsSubtextHtml: defaultSlotHtml.emailEventDetailsSubtextHtml,
            emailBadgeHtml: defaultSlotHtml.emailBadgeHtml,
            emailButtonTextHtml: defaultSlotHtml.emailButtonTextHtml
        }
    });
    const loadedTemplateKey = useMemo(() => `${selectedEmailTemplate?.id ?? ''}|${selectedEmailTemplate?.bodyTemplateHtml ?? ''}`, [selectedEmailTemplate?.id, selectedEmailTemplate?.bodyTemplateHtml]);
    const loadedTemplateKeyRef = useRef(null);
    useEffect(() => {
        if (loadedTemplateKeyRef.current === loadedTemplateKey)
            return;
        loadedTemplateKeyRef.current = loadedTemplateKey;
        if (selectedEmailTemplate?.bodyTemplateHtml) {
            try {
                const parsed = JSON.parse(selectedEmailTemplate.bodyTemplateHtml);
                reset({
                    emailHeadingHtml: prepareHeadingEditorHtml(parsed.emailHeading ?? ''),
                    emailBodyHtml: wrapMetaTagsInSpans(parsed.emailBody ?? ''),
                    emailEventDetailsHeadingHtml: wrapMetaTagsInSpans(parsed.emailEventDetailsHeading ?? ''),
                    emailEventDetailsSubtextHtml: wrapMetaTagsInSpans(parsed.emailEventDetailsSubtext ?? ''),
                    emailBadgeHtml: wrapMetaTagsInSpans(parsed.emailBadge ?? ''),
                    emailButtonTextHtml: wrapMetaTagsInSpans(parsed.emailButtonText ?? '')
                });
            }
            catch {
                reset({
                    emailHeadingHtml: defaultSlotHtml.emailHeadingHtml,
                    emailBodyHtml: defaultSlotHtml.emailBodyHtml,
                    emailEventDetailsHeadingHtml: defaultSlotHtml.emailEventDetailsHeadingHtml,
                    emailEventDetailsSubtextHtml: defaultSlotHtml.emailEventDetailsSubtextHtml,
                    emailBadgeHtml: defaultSlotHtml.emailBadgeHtml,
                    emailButtonTextHtml: defaultSlotHtml.emailButtonTextHtml
                });
            }
        }
        else {
            reset({
                emailHeadingHtml: defaultSlotHtml.emailHeadingHtml,
                emailBodyHtml: defaultSlotHtml.emailBodyHtml,
                emailEventDetailsHeadingHtml: defaultSlotHtml.emailEventDetailsHeadingHtml,
                emailEventDetailsSubtextHtml: defaultSlotHtml.emailEventDetailsSubtextHtml,
                emailBadgeHtml: defaultSlotHtml.emailBadgeHtml,
                emailButtonTextHtml: defaultSlotHtml.emailButtonTextHtml
            });
        }
    }, [loadedTemplateKey, selectedEmailTemplate?.bodyTemplateHtml, reset, defaultSlotHtml]);
    useLayoutEffect(() => {
        restoreConfigureEmailScroll(editorScrollPanelRef.current);
    }, [selectedEmailTemplate?.id, selectedEmailTemplate?.bodyTemplateHtml, templateType]);
    useEffect(() => {
        restoreConfigureEmailScroll(editorScrollPanelRef.current);
    }, [selectedEmailTemplate?.id, selectedEmailTemplate?.bodyTemplateHtml, templateType]);
    const emailHeadingHtml = watch('emailHeadingHtml');
    const emailBodyHtml = watch('emailBodyHtml');
    const emailEventDetailsHeadingHtml = watch('emailEventDetailsHeadingHtml');
    const emailEventDetailsSubtextHtml = watch('emailEventDetailsSubtextHtml');
    const emailBadgeHtml = watch('emailBadgeHtml');
    const emailButtonTextHtml = watch('emailButtonTextHtml');
    const handleInsertMetaTag = (id) => {
        const scrollAnchor = editorScrollPanelRef.current ?? document.body;
        const pageScrollSnapshot = captureScrollPositions(scrollAnchor);
        const token = `{{${id}}}`;
        const wrapped = wrapMetaTagsInSpans(`<p>${token}</p>`);
        const targetName = activeEditorNameRef.current ?? activeEditorName ?? 'emailHeadingHtml';
        const targetRef = editorRefs[targetName];
        targetRef?.current?.insertAtCursor(wrapped);
        setInsertMenuAnchor(null);
        restoreScrollPositionsDeferred(pageScrollSnapshot);
    };
    const handleResetToDefault = () => {
        setValue('emailHeadingHtml', defaultSlotHtml.emailHeadingHtml);
        setValue('emailBodyHtml', defaultSlotHtml.emailBodyHtml);
        setValue('emailEventDetailsHeadingHtml', defaultSlotHtml.emailEventDetailsHeadingHtml);
        setValue('emailEventDetailsSubtextHtml', defaultSlotHtml.emailEventDetailsSubtextHtml);
        setValue('emailBadgeHtml', defaultSlotHtml.emailBadgeHtml);
        setValue('emailButtonTextHtml', defaultSlotHtml.emailButtonTextHtml);
        setHeaderImageFile(null);
        setFeatureImageFile(null);
        setShowHeaderImage(true);
        setShowFeatureImage(true);
        setImagesResetToDefault(true);
        toast.success(t('events.eventDetails.preferencesTab.resetToDefault', 'Reset to default'));
    };
    const handleSaveChanges = async () => {
        if (!eventId) {
            toast.error(t('events.eventDetails.preferencesTab.invalidEvent', 'Invalid event.'));
            return;
        }
        if (!selectedEmailTemplate?.languageId) {
            toast.error(t('events.eventDetails.preferencesTab.selectLanguageFirst', 'English language not found.'));
            return;
        }
        const images = [];
        if (headerImageFile) {
            images.push({
                imageRole: EmailTemplateImageRole.Header,
                sortOrder: 1,
                isActive: true,
                image: headerImageFile,
                name: headerImageFile.name,
                fileTitle: headerImageFile.name,
                altText: 'Header image'
            });
        }
        else if (!imagesResetToDefault) {
            const existingHeader = selectedEmailTemplate?.images?.find((img) => img.imageRole === EmailTemplateImageRole.Header);
            if (existingHeader) {
                images.push({
                    imageRole: EmailTemplateImageRole.Header,
                    sortOrder: existingHeader.sortOrder,
                    isActive: existingHeader.isActive,
                    name: existingHeader.name,
                    folderName: existingHeader.folderName,
                    fileSize: existingHeader.fileSize,
                    url: existingHeader.url,
                    fileTitle: existingHeader.fileTitle,
                    altText: existingHeader.altText
                });
            }
        }
        if (featureImageFile) {
            images.push({
                imageRole: EmailTemplateImageRole.Body,
                sortOrder: 2,
                isActive: true,
                image: featureImageFile,
                name: featureImageFile.name,
                fileTitle: featureImageFile.name,
                altText: 'Feature image'
            });
        }
        else if (!imagesResetToDefault) {
            const existingFeature = selectedEmailTemplate?.images?.find((img) => img.imageRole === EmailTemplateImageRole.Body);
            if (existingFeature) {
                images.push({
                    imageRole: EmailTemplateImageRole.Body,
                    sortOrder: existingFeature.sortOrder,
                    isActive: existingFeature.isActive,
                    name: existingFeature.name,
                    folderName: existingFeature.folderName,
                    fileSize: existingFeature.fileSize,
                    url: existingFeature.url,
                    fileTitle: existingFeature.fileTitle,
                    altText: existingFeature.altText
                });
            }
        }
        try {
            const normalizedHeadingHtml = labelsToTokens(emailHeadingHtml ?? '', labelToTokenMap);
            const normalizedBodyHtml = labelsToTokens(emailBodyHtml ?? '', labelToTokenMap);
            const normalizedDetailsHeadingHtml = labelsToTokens(emailEventDetailsHeadingHtml ?? '', labelToTokenMap);
            const normalizedDetailsSubtextHtml = labelsToTokens(emailEventDetailsSubtextHtml ?? '', labelToTokenMap);
            const normalizedBadgeHtml = stripEditorParagraphTags(flattenEmailSingleLineParagraphs(labelsToTokens(emailBadgeHtml ?? '', labelToTokenMap)));
            const normalizedButtonTextHtml = stripEditorParagraphTags(flattenEmailSingleLineParagraphs(labelsToTokens(emailButtonTextHtml ?? '', labelToTokenMap)));
            const emailBodyPayload = {
                emailHeading: normalizedHeadingHtml,
                emailBody: normalizedBodyHtml,
                emailEventDetailsHeading: normalizedDetailsHeadingHtml,
                emailEventDetailsSubtext: normalizedDetailsSubtextHtml,
                emailBadge: normalizedBadgeHtml,
                emailButtonText: normalizedButtonTextHtml
            };
            await dispatch(upsertEmailTemplateAsync({
                eventId,
                languageId: selectedEmailTemplate?.languageId,
                templateType: selectedEmailTemplate?.templateType ?? templateType,
                status: EmailTemplateStatus.Draft,
                isActive: true,
                showHeaderImage,
                showFeatureImage,
                name: templateTitle ?? '',
                subjectTemplate: '',
                bodyTemplateHtml: JSON.stringify(emailBodyPayload),
                images
            })).unwrap();
            toast.success(t('events.eventDetails.preferencesTab.saved', 'Changes saved'));
        }
        catch (error) {
            const err = error;
            toast.error(err?.error ||
                t('events.eventDetails.preferencesTab.failedToSaveChanges', 'Failed to save changes'));
        }
    };
    const insertMenuOpen = Boolean(insertMenuAnchor);
    const insertMenuActions = useMemo(() => {
        return (identityFormFields ?? []).map((field) => ({
            text: field.label,
            group: true,
            to: () => handleInsertMetaTag(field.label)
        }));
    }, [identityFormFields]);
    return (_jsxs(Box, { children: [_jsxs(Grid, { container: true, spacing: '20px', sx: { alignItems: 'stretch' }, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '20px', children: [_jsxs(Box, { sx: {
                                        display: 'flex',
                                        alignItems: isMobile ? 'undefined' : 'center',
                                        justifyContent: 'space-between',
                                        flexDirection: isMobile ? 'column' : 'row',
                                        gap: 1
                                    }, children: [_jsx(Typography, { variant: 'h5', color: 'textPrimary', children: templateTitle
                                                ? GetTranslatedTitle(templateTitle)
                                                : t('sponsorships.preferencesTab.emailPreferences') }), _jsxs(Box, { display: 'flex', gap: 1, alignItems: 'center', justifyContent: isMobile ? 'flex-end' : undefined, children: [isMobile && (_jsx(Button, { size: 'small', variant: 'outlined', color: 'primary', onClick: () => setIsPreviewDrawerOpen(true), children: t('events.eventDetails.preferencesTab.previewEmail') })), _jsx(InfoIconTooltip, { variant: 'light', title: t('events.eventDetails.preferencesTab.insertTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) }), _jsx(Button, { size: 'medium', variant: 'outlined', color: 'inherit', endIcon: _jsx(KeyboardArrowDownIcon, { sx: {
                                                            transition: 'transform 0.2s ease',
                                                            transform: insertMenuOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                                                        } }), onClick: (e) => setInsertMenuAnchor(e.currentTarget), disabled: !canUpdateEvents, children: t('events.eventDetails.preferencesTab.insert', 'Insert') }), insertMenuOpen && (_jsx(StyledMenu, { anchorEl: insertMenuAnchor, open: insertMenuOpen, onClose: () => setInsertMenuAnchor(null), disableRestoreFocus: true, actions: insertMenuActions, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' } }))] })] }), _jsxs(Box, { ref: editorScrollPanelRef, display: 'flex', flexDirection: 'column', gap: '20px', overflow: 'auto', height: 'calc(100dvh - 235px)', children: [_jsxs(Box, { sx: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 1
                                            }, children: [_jsxs(Box, { sx: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        borderRadius: 2,
                                                        backgroundColor: (theme) => theme.palette.background.neutral,
                                                        p: 1.5
                                                    }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5 }, children: [showHeaderImage && (headerImagePreview || (!imagesResetToDefault && selectedEmailTemplate?.images?.[0]?.url)) && (_jsx(Box, { component: 'img', src: headerImagePreview || selectedEmailTemplate?.images?.[0]?.url, alt: headerImagePreview ||
                                                                        t('events.eventDetails.preferencesTab.headerImage'), sx: {
                                                                        width: 40,
                                                                        height: 40,
                                                                        borderRadius: 1,
                                                                        objectFit: 'cover'
                                                                    } })), _jsx(Typography, { variant: 'body2', color: 'textPrimary', children: t('events.eventDetails.preferencesTab.headerImage') })] }), _jsxs(Box, { display: 'flex', gap: '12px', alignItems: 'center', children: [_jsx(Switch, { checked: showHeaderImage, onChange: (e) => setShowHeaderImage(e.target.checked), disabled: !canUpdateEvents }), _jsx(Button, { size: 'small', variant: 'outlined', color: 'inherit', disabled: !canUpdateEvents || showHeaderImage === false, onClick: () => {
                                                                        const input = document.createElement('input');
                                                                        input.type = 'file';
                                                                        input.accept = 'image/*';
                                                                        input.onchange = (e) => {
                                                                            const file = e.target.files?.[0];
                                                                            if (!file)
                                                                                return;
                                                                            setHeaderImageFile(file);
                                                                            setImagesResetToDefault(false);
                                                                        };
                                                                        input.click();
                                                                    }, children: t('events.eventDetails.preferencesTab.change') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.headerImageTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] })] }), templateType === EmailTemplateType.Invitation ||
                                                    templateType === EmailTemplateType.ReInvitationReminder ||
                                                    templateType === EmailTemplateType.RegisteredReminder ? (_jsxs(Box, { sx: {
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        borderRadius: 2,
                                                        backgroundColor: (theme) => theme.palette.background.neutral,
                                                        p: 1.5
                                                    }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5 }, children: [showFeatureImage && (featureImagePreview || (!imagesResetToDefault && selectedEmailTemplate?.images?.find(img => img.imageRole === EmailTemplateImageRole.Body)?.url)) && (_jsx(Box, { component: 'img', src: featureImagePreview || selectedEmailTemplate?.images?.find(img => img.imageRole === EmailTemplateImageRole.Body)?.url, alt: featureImagePreview ||
                                                                        t('events.eventDetails.preferencesTab.featureImage'), sx: {
                                                                        width: 40,
                                                                        height: 40,
                                                                        borderRadius: 1,
                                                                        objectFit: 'cover'
                                                                    } })), _jsx(Typography, { variant: 'body2', color: 'textPrimary', children: t('events.eventDetails.preferencesTab.featureImage') })] }), _jsxs(Box, { display: 'flex', gap: '12px', alignItems: 'center', children: [_jsx(Switch, { checked: showFeatureImage, onChange: (e) => setShowFeatureImage(e.target.checked), disabled: !canUpdateEvents }), _jsx(Button, { size: 'small', variant: 'outlined', color: 'inherit', disabled: !canUpdateEvents || showFeatureImage === false, onClick: () => {
                                                                        const input = document.createElement('input');
                                                                        input.type = 'file';
                                                                        input.accept = 'image/*';
                                                                        input.onchange = (e) => {
                                                                            const file = e.target.files?.[0];
                                                                            if (!file)
                                                                                return;
                                                                            setFeatureImageFile(file);
                                                                            setImagesResetToDefault(false);
                                                                        };
                                                                        input.click();
                                                                    }, children: t('events.eventDetails.preferencesTab.change') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.featureImageTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] })] })) : null] }), _jsxs(Box, { sx: { flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }, children: [_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '13px', padding: '12px', borderRadius: 2, bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: t('events.eventDetails.preferencesTab.emailBadgeContent') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.emailBadgeContentTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] }), _jsx(EmailBodyEditor, { control: control, name: 'emailBadgeHtml', tokenToLabelMap: tokenToLabelMap, labelToTokenMap: labelToTokenMap, editorRef: badgeEditorRef, onEditorFocus: handleEditorFocus, forceSyncToken: loadedTemplateKey })] }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '13px', padding: '12px', borderRadius: 2, bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: t('events.eventDetails.preferencesTab.emailHeadingContent') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.emailHeadingContentTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] }), _jsx(EmailBodyEditor, { control: control, name: 'emailHeadingHtml', tokenToLabelMap: tokenToLabelMap, labelToTokenMap: labelToTokenMap, editorRef: headingEditorRef, onEditorFocus: handleEditorFocus, forceSyncToken: loadedTemplateKey })] }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '13px', padding: '12px', borderRadius: 2, bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: t('events.eventDetails.preferencesTab.emailBodyContent') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.emailBodyContentTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] }), _jsx(EmailBodyEditor, { control: control, name: 'emailBodyHtml', tokenToLabelMap: tokenToLabelMap, labelToTokenMap: labelToTokenMap, editorRef: bodyEditorRef, onEditorFocus: handleEditorFocus, forceSyncToken: loadedTemplateKey })] }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '13px', padding: '12px', borderRadius: 2, bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: t('events.eventDetails.preferencesTab.emailEventDetailsHeadingContent') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.emailEventDetailsHeadingContentTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] }), _jsx(EmailBodyEditor, { control: control, name: 'emailEventDetailsHeadingHtml', tokenToLabelMap: tokenToLabelMap, labelToTokenMap: labelToTokenMap, editorRef: detailsHeadingEditorRef, onEditorFocus: handleEditorFocus, forceSyncToken: loadedTemplateKey })] }), templateType !== EmailTemplateType.Ticket && (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '13px', padding: '12px', borderRadius: 2, bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: t('events.eventDetails.preferencesTab.emailEventDetailsSubtextContent') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.emailEventDetailsSubtextContentTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] }), _jsx(EmailBodyEditor, { control: control, name: 'emailEventDetailsSubtextHtml', tokenToLabelMap: tokenToLabelMap, labelToTokenMap: labelToTokenMap, editorRef: detailsSubtextEditorRef, onEditorFocus: handleEditorFocus, forceSyncToken: loadedTemplateKey })] })), (templateType === EmailTemplateType.Invitation ||
                                                    templateType === EmailTemplateType.Ticket ||
                                                    templateType === EmailTemplateType.ReInvitationReminder) && (_jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '13px', padding: '12px', borderRadius: 2, bgcolor: theme.palette.background.neutral, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'subtitle1', children: t('events.eventDetails.preferencesTab.emailButtonTextContent') }), _jsx(InfoIconTooltip, { variant: 'dark', title: t('events.eventDetails.preferencesTab.emailButtonTextContentTooltip'), icon: _jsx(Icon, { icon: 'eva:question-mark-circle-outline', width: '24', height: '24', color: theme.palette.info.dark }) })] }), _jsx(EmailBodyEditor, { control: control, name: 'emailButtonTextHtml', tokenToLabelMap: tokenToLabelMap, labelToTokenMap: labelToTokenMap, editorRef: buttonTextEditorRef, onEditorFocus: handleEditorFocus, forceSyncToken: loadedTemplateKey })] })), _jsxs(Box, { sx: {
                                                        display: 'flex',
                                                        gap: 2,
                                                        justifyContent: 'flex-end',
                                                        px: 2,
                                                        py: 2,
                                                        borderTop: (t) => `1px solid ${t.palette.divider}`
                                                    }, children: [_jsx(Button, { variant: 'outlined', onClick: handleResetToDefault, disabled: !canUpdateEvents, children: t('events.eventDetails.preferencesTab.reset') }), _jsx(Button, { variant: 'contained', onClick: handleSaveChanges, disabled: !canUpdateEvents || emailTemplateStatus === APIStatus.PENDING, children: t('events.eventDetails.preferencesTab.saveChanges') })] })] })] })] }) }), !isMobile && (_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(EmailPreview, { htmlTemplate: templateDefaults.htmlTemplate, emailHeadingHtml: tokensToDisplayLabels(emailHeadingHtml ?? '', tokenToLabelMap), emailBodyHtml: tokensToDisplayLabels(emailBodyHtml ?? '', tokenToLabelMap), emailEventDetailsHeadingHtml: tokensToDisplayLabels(emailEventDetailsHeadingHtml ?? '', tokenToLabelMap), emailEventDetailsSubtextHtml: tokensToDisplayLabels(emailEventDetailsSubtextHtml ?? '', tokenToLabelMap), emailBadgeHtml: tokensToDisplayLabels(emailBadgeHtml ?? '', tokenToLabelMap), emailButtonTextHtml: tokensToDisplayLabels(emailButtonTextHtml ?? '', tokenToLabelMap), placeholderValues: {
                                ...templateDefaults.placeholderValues,
                                ...eventPlaceholderOverrides
                            }, companyLogoPlaceholder: companyLogoPlaceholderOverride }) }))] }), isMobile && (_jsx(BDrawer, { anchor: 'bottom', open: isPreviewDrawerOpen, onClose: () => setIsPreviewDrawerOpen(false), title: t('events.eventDetails.preferencesTab.emailPreview', 'Email preview'), children: _jsx(EmailPreview, { htmlTemplate: templateDefaults.htmlTemplate, emailHeadingHtml: tokensToDisplayLabels(emailHeadingHtml ?? '', tokenToLabelMap), emailBodyHtml: tokensToDisplayLabels(emailBodyHtml ?? '', tokenToLabelMap), emailEventDetailsHeadingHtml: tokensToDisplayLabels(emailEventDetailsHeadingHtml ?? '', tokenToLabelMap), emailEventDetailsSubtextHtml: tokensToDisplayLabels(emailEventDetailsSubtextHtml ?? '', tokenToLabelMap), emailBadgeHtml: tokensToDisplayLabels(emailBadgeHtml ?? '', tokenToLabelMap), emailButtonTextHtml: tokensToDisplayLabels(emailButtonTextHtml ?? '', tokenToLabelMap), placeholderValues: {
                        ...templateDefaults.placeholderValues,
                        ...eventPlaceholderOverrides
                    }, companyLogoPlaceholder: companyLogoPlaceholderOverride }) }))] }));
};
export default EmailConfiguration;
